export default __webpack_public_path__ + "static/media/workoutscf@3x.04241835.png";